// Module
var code = "<div title=\"{{row.entity.status}}\" class=\"ui-grid-cell-contents\" ng-bind=\"row.entity.status\"></div>";
// Exports
module.exports = code;